import { getConfig, URLS, ACCOUNT_HOST } from '@constants';

import { EApiUpstream } from '@enums';

import { cookies, updateLinkParams } from '@utils';

import { BaseApi } from '../BaseApi';

import { IApiResponse } from '@interfaces';

import { IApiCurrentUserAuthRequestParams, IUserResponse } from './types';

export class CurrentUserApi extends BaseApi {

	async auth(params: IApiCurrentUserAuthRequestParams) {
		return this.post({
			url: '/api-auth/auth',
			data: params,
			upstream: EApiUpstream.MPOP,
		});
	}

	async getCurrentUser(): Promise<IApiResponse<IUserResponse>> {
		return await this.get({
			url: '/+/user/current',
			upstream: EApiUpstream.MYDAWN,
		});
	}

	// identification - email пользователя, либо его auid
	async getUser(identification: string | number): Promise<IApiResponse<IUserResponse>> {
		return await this.get({
			url: `/+/user/${identification}`,
			upstream: EApiUpstream.MYDAWN,
		});
	}

	async sdc() {
		return this.get({
			url: `/api-auth/sdc?from=${encodeURIComponent(getConfig()?.hosts?.baseUrlDesktop) || 'https://m.my.mail.ru'}`,
			upstream: EApiUpstream.MPOP,
		});
	}

	async createMyByEmail(email: string) {
		return this.post({
			url: `${URLS.AJAX}?func_name=welcome.create_my&xemail=${email}`,
			upstream: EApiUpstream.MPOP,
		});
	}

	async createMy() {
		return this.get({
			url: URLS.WAPI,
			params: {
				method: 'users.createMy',
				dump: 1,
			},
			upstream: EApiUpstream.MPOP,
		});
	}

	logIn(successRedirectUrl?: string) {
		const appsPathname = `${window.location.origin}${getConfig().apps.pathname || URLS.APPS}`;

		if (location.hostname === 'localhost') {
			window.location.href = `${window.location.origin}?page=${window.location.href}`;
		} else if (getConfig().isOpenStack) {
			location.href = updateLinkParams(
				// по этому вопросу общаюсь с порталом
				URLS.MAIN,
				// URLS.LOG_IN,
				{
					page: successRedirectUrl || appsPathname,
					back: successRedirectUrl || appsPathname,
				},
			);
		} else {
			location.href = updateLinkParams(
				URLS.ACCOUNT_MAIL_RU_LOGIN,
				{
					'project': 'my',
					'mobile_redirect': 1,
					'type': 'login',
					'account_host': ACCOUNT_HOST,
					'success_redirect': successRedirectUrl || appsPathname,
					'parent_url': successRedirectUrl || appsPathname,
					'back': successRedirectUrl || appsPathname,
					'vk': 1,
					'ok': 1,
				},
			);
		}
	}

	registration(successRedirectUrl?: string) {
		const appsPathname = `${window.location.origin}${getConfig().apps.pathname || URLS.APPS}`;

		location.href = updateLinkParams(
			URLS.ACCOUNT_MAIL_RU_REGISTRATION,
			{
				'project': 'my',
				'mobile_redirect': 1,
				'SignupMymailRu': 1,
				'type': 'signup',
				'account_host': ACCOUNT_HOST,
				'success_redirect': successRedirectUrl || appsPathname,
				'parent_url': successRedirectUrl || appsPathname,
				'back': successRedirectUrl || appsPathname,
			},
		);
	}

	logout() {
		const appsPathname = `${window.location.origin}${getConfig().apps.pathname || URLS.APPS}`;

		if (location.hostname === 'localhost') {
			cookies.delete('Mpop');
		} else {
			location.href = updateLinkParams(
				URLS.LOGOUT,
				{
					page: appsPathname,
				},
			);
		}
	}

}
